import { currencyFormatter } from "./formatting";

const  {  ACADEMIC_LEVEL_IDENTIFIERS, DEADLINES, SPACING_IDENTIFIERS, TYPE_OF_PAPERS_MULTIPLIERS, TYPE_OF_ENGLISH_MULTIPLIERS, WRITING_TYPES_MULTIPLIERS } = require("../constants/commonConstants")



export const calculateCost = ({
    academicLevel,
    deadline,
    spacing,
    pages,
    typeOfPaper,
    budgetIncrement=0,
    writingType,
    typeOfEnglish
  }) => {
      try{
          
        if(!deadline || !spacing || !pages || !typeOfPaper || !academicLevel || !writingType || !typeOfEnglish){
            return currencyFormatter.format(0);
        }

        deadline = DEADLINES.find(element => element.name === deadline)?.value
        if(!deadline){
            return currencyFormatter.format(0);
        }
        
        let costPerPage; // Base Cost Per Page
    
        //base cost
      if (academicLevel === ACADEMIC_LEVEL_IDENTIFIERS.COLLEGE ) {
    
        switch(deadline){
            case 21:
                costPerPage = 9 + 2
                break
            case 14:
                costPerPage = 11 + 2
                break
            case 10:
                costPerPage = 13 + 2
                break
            case 6:
                costPerPage = 15 + 2
                break
            case 4:
                costPerPage = 17 + 2
                break
            case 2:
                costPerPage = 19 + 2
                break
            case 1:
                costPerPage = 25 + 2
                break
            case 0.5: 
                costPerPage = 30 + 2
                break
            case 0.25:
                costPerPage = 35 + 2
                break
            case 0.125:
                costPerPage = 40 + 2
                break
        }
    
      } else if (academicLevel === ACADEMIC_LEVEL_IDENTIFIERS.UNIVERSITY) {
    
        switch(deadline){
            case 21:
                costPerPage = 10 + 2
                break
            case 14:
                costPerPage = 12 + 2
                break
            case 10:
                costPerPage = 14 + 2
                break
            case 6:
                costPerPage = 16 + 2
                break
            case 4:
                costPerPage = 18 + 2
                break
            case 2:
                costPerPage = 20 + 2
                break
            case 1:
                costPerPage = 27 + 2
                break
            case 0.5: 
                costPerPage = 32 + 2
                break
            case 0.25:
                costPerPage = 37 + 2
                break
            case 0.125:
                costPerPage = 42 + 2
                break
        }
    
      } else if (academicLevel === ACADEMIC_LEVEL_IDENTIFIERS.MASTERS) {
    
        switch(deadline){
            case 21:
                costPerPage = 12 + 2
                break
            case 14:
                costPerPage = 14 + 2
                break
            case 10:
                costPerPage = 16 + 2
                break
            case 6:
                costPerPage = 18 + 2
                break
            case 4:
                costPerPage = 20 + 2
                break
            case 2:
                costPerPage = 22 + 2
                break
            case 1:
                costPerPage = 29 + 2
                break
            case 0.5: 
                costPerPage = 36 + 2
                break
            case 0.25:
                costPerPage = 43 + 2
                break
            case 0.125:
                costPerPage = 50 + 2
                break
        }
    
      } else if (academicLevel === ACADEMIC_LEVEL_IDENTIFIERS.DOCTORATE) {
    
        switch(deadline){
            case 21:
                costPerPage = 14 + 2
                break
            case 14:
                costPerPage = 16 + 2
                break
            case 10:
                costPerPage = 18 + 2
                break
            case 6:
                costPerPage = 20 + 2
                break
            case 4:
                costPerPage = 22 + 2
                break
            case 2:
                costPerPage = 24 + 2
                break
            case 1:
                costPerPage = 31 + 2
                break
            case 0.5: 
                costPerPage = 39 + 2
                break
            case 0.25:
                costPerPage = 46 + 2
                break
            case 0.125:
                costPerPage = 53 + 2
                break
        }
      }
    
        // Adjust cost per page for spacing
        if (spacing === SPACING_IDENTIFIERS.SINGLE_SPACING) {
            costPerPage *= 2;
        }
    
        //extra cost for selected paper types
        const paperTypeMultiplyer = TYPE_OF_PAPERS_MULTIPLIERS.find(paper => paper.name === typeOfPaper)?.paperTypeMultiplier || 0
        const writingTypeMultiplier = WRITING_TYPES_MULTIPLIERS.find(type => type.name === writingType)?.writingTypeMultiplier || 0
        const englishTypeMultiplier = TYPE_OF_ENGLISH_MULTIPLIERS.find(type => type.name === typeOfEnglish)?.englishTypeMultiplier || 0

        let totalCost = Math.round(
            costPerPage * pages * paperTypeMultiplyer * writingTypeMultiplier * englishTypeMultiplier
        )
    
        // Apply a discount for Powerpoint presentations (70% cheaper)
        if (typeOfPaper === "Powerpoint") {
            totalCost *= 0.7; // Reduce total cost by 30%
        }
        totalCost += budgetIncrement

        if(isNaN(totalCost)){
            return currencyFormatter.format(0);
        }

        return (currencyFormatter.format(totalCost.toFixed(2))) || "$ 0.00"

    }catch(error){
        console.log(error);
        return currencyFormatter.format(0);
    }
}